/**
 * Settings 画面: プロフィール / FocusPolicy / 入力プリファレンス / ログアウト。
 */

import { TitleBar } from '../components/TitleBar';
import { navigate } from '../lib/navigate';
import { type FocusPolicy, usePrefs } from '../state/prefs';
import { useSession } from '../state/session';

export function Settings() {
  const me = useSession((s) => s.me);
  const logout = useSession((s) => s.logout);
  const focusPolicy = usePrefs((s) => s.focusPolicy);
  const setFocusPolicy = usePrefs((s) => s.setFocusPolicy);
  const soundEnabled = usePrefs((s) => s.soundEnabled);
  const setSound = usePrefs((s) => s.setSound);

  return (
    <main className="app-shell">
      <TitleBar title="設定" back={{ href: '/' }} />

      {me && (
        <section>
          <h3>プロフィール</h3>
          <div className="profile-card">
            <div className="profile-avatar" aria-hidden>
              {(me.handle ?? me.email).slice(0, 1).toUpperCase()}
            </div>
            <div>
              <div className="profile-name">{me.handle ?? '(未設定)'}</div>
              <small>{me.email}</small>
            </div>
          </div>
        </section>
      )}

      <section>
        <h3>盤の自動切替</h3>
        <fieldset className="radio-group">
          <RadioRow
            name="focus"
            value="AutoOnOpponentMove"
            current={focusPolicy}
            onChange={(v) => setFocusPolicy(v as FocusPolicy)}
            label="相手着手で自動切替 (推奨)"
          />
          <RadioRow
            name="focus"
            value="Manual"
            current={focusPolicy}
            onChange={(v) => setFocusPolicy(v as FocusPolicy)}
            label="手動切替のみ"
          />
        </fieldset>
      </section>

      <section>
        <h3>通知</h3>
        <label className="check-row">
          <input
            type="checkbox"
            checked={soundEnabled}
            onChange={(e) => setSound(e.target.checked)}
          />
          効果音 (駒音 + クロック警告)
        </label>
      </section>

      {/* 設定自体は localStorage なのでログイン不要。 アカウント操作だけ出し分ける。 */}
      <section className="home-actions">
        {me ? (
          <button
            className="btn-secondary"
            onClick={async () => {
              await logout();
              navigate('/');
            }}
          >
            ログアウト
          </button>
        ) : (
          <a className="btn-secondary" href="/login?redirect=/settings">
            ログイン
          </a>
        )}
      </section>
    </main>
  );
}

function RadioRow({
  name,
  value,
  current,
  onChange,
  label,
}: {
  name: string;
  value: string;
  current: string;
  onChange: (v: string) => void;
  label: string;
}) {
  return (
    <label className="radio-row">
      <input
        type="radio"
        name={name}
        checked={current === value}
        onChange={() => onChange(value)}
      />
      {label}
    </label>
  );
}
